export default __webpack_public_path__ + "static/media/studio-set-up.e61753f9.svg";